/*
  Header behaviour for sections/pf-header.liquid: the off-canvas drawer
  below 990px, the dropdown toggle buttons (hover/focus open the menus on
  desktop via CSS; the buttons cover touch and keyboard), Escape and
  outside-click to close. Re-initialises on shopify:section:load.
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    var toggle = root.querySelector('[data-pf-nav-toggle]');
    var overlay = root.querySelector('[data-pf-nav-close]');

    function setOpen(open) {
      root.classList.toggle('nav-open', open);
      document.documentElement.classList.toggle('pfb-nav-lock', open);
      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }
      if (overlay) overlay.hidden = !open;
      if (!open) closeSubs();
    }

    function closeSubs(except) {
      root.querySelectorAll('.pfb-nav-item.is-open').forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector('[data-pf-sub]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    if (toggle) toggle.addEventListener('click', function () { setOpen(!root.classList.contains('nav-open')); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pf-sub]');
      if (!btn) return;
      var li = btn.closest('.pfb-nav-item');
      var open = !li.classList.contains('is-open');
      closeSubs(li);
      li.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeSubs();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('nav-open')) { setOpen(false); if (toggle) toggle.focus(); }
      else closeSubs();
    });

    /* Leaving the drawer breakpoint while open would leave the page locked. */
    var mq = window.matchMedia('(min-width: 990px)');
    var onChange = function (ev) { if (ev.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
  }

  function boot() { document.querySelectorAll('[data-pf-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
